import './priceField.css'

const PriceField = ({
  locationPaymentType,
  startPriceAmount,
  startPriceDuration,
  mainPriceAmount,
  mainPriceDuration,
}: {
  locationPaymentType: number,
  startPriceAmount: number,
  startPriceDuration: number,
  mainPriceAmount: number,
  mainPriceDuration: number
}) => {

  const Content = () => {
    if (startPriceAmount === 0 && mainPriceAmount === 0) {
      // FREE
      return (
        <p className={'leftText'}>{'GRATIS'}</p>
      );
    }
    if (mainPriceAmount > 0) {
      // INTERVAL
      return (
        <>
          {startPriceAmount === 0 && startPriceDuration > 0 && (
            <div className={'priceWrapper'}>
              <p className={'leftText'}>
                {'Første'} {startPriceDuration}{' '}
                {`t`}
              </p>
              <p className={'rightText'}>
                {'GRATIS'}
              </p>
            </div>
          )}

          {startPriceAmount > 0 && (
            <div className={'priceWrapper'}>
              <p className={'leftText'}>
                {'For første'}{' '}{startPriceDuration}{' '}
                {'t'},
              </p>
              <p className={'rightText'}>
                {startPriceAmount} kr
              </p>
            </div>
          )}
          <div className={'divider'} />
          <div className={'priceWrapper'}>
            <p className={'leftText'}>
              {'Hver'}{' '}
              {mainPriceDuration}{' '}
              {!!(startPriceAmount && startPriceDuration)
                ? 't deretter'
                : 't'}
            </p>
            <p className={'rightText'}>
              {mainPriceAmount} kr
            </p>
          </div>
        </>
      );
    }
    if (startPriceAmount > 0 && mainPriceAmount === 0) {
      // ONE TIME
      return (
        <p className={'leftText'}>
          <p className={'leftText'}>kr {startPriceAmount} </p>(
          {'En gang'})
        </p>
      );
    }
    return null;
  };

  return (
    <Content />
  );
};


export default PriceField;
